// Excel-Export der Listen eines Projekts (Knopf „Excel“ in den Ansichten) – reine Hilfen ohne React, damit sie sich testen lassen.
// Die Datei entsteht auf dem Server (Projects.Kern/Listenexport.cs): alle Einträge im gespeicherten Stand, ohne Filter.
export type ExportBereich = 'aufgaben' | 'entscheidungen' | 'meilensteine' | 'offene-punkte' | 'tests' | 'checklisten' | 'abnahmen';

export const EXPORT_BEREICH: Record<ExportBereich, string> = {
  aufgaben: 'Aufgaben', entscheidungen: 'Entscheidungen', meilensteine: 'Meilensteine und Phasen', 'offene-punkte': 'Offene Punkte',
  tests: 'Testfälle', checklisten: 'Checklisten', abnahmen: 'Abnahmen',
};

/** Dateiname aus dem Kopf „Content-Disposition“ (filename*=UTF-8''… vor filename=…), sonst der Ersatz. */
export function dateinameAus(kopf: string | null | undefined, ersatz: string): string {
  if (!kopf) return ersatz;
  const stern = kopf.match(/filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/);
  if (stern) {
    try { return decodeURIComponent(stern[1].trim()) || ersatz; } catch { /* unlesbar: weiter mit filename= */ }
  }
  const schlicht = kopf.match(/filename\s*=\s*("([^"]*)"|[^;]+)/);
  const name = (schlicht?.[2] ?? schlicht?.[1] ?? '').trim();
  return name && !name.startsWith('=?') ? name : ersatz;
}
